import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const reasons = ['Feel relief in minutes', 'Use it anywhere', 'No expensive therapy needed'];
export function WhyPeopleLoveIt() {
  return <section className="bg-white py-16 px-4 sm:px-6 lg:px-8 border-b border-brand-gray-light" data-id="element-187">
      <div className="max-w-4xl mx-auto" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-gray-light rounded-3xl p-8 sm:p-12" data-id="element-189">
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-brand-black mb-8" data-id="element-190">
            Why People Love It
          </h2>
          <div className="flex flex-col sm:flex-row justify-center items-center sm:items-start gap-6 sm:gap-12" data-id="element-191">
            {reasons.map((reason, index) => <div key={index} className="flex items-center gap-3" data-id="element-192">
                <CheckCircle2 className="w-6 h-6 text-brand-purple flex-shrink-0" data-id="element-193" />
                <span className="text-lg font-medium text-brand-black" data-id="element-194">
                  {reason}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}